/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ItemFromJSON, ItemToJSON, } from './Item.js';
/**
 * Check if a given object implements the ListManagedCompaniesResult interface.
 */
export function instanceOfListManagedCompaniesResult(value) {
    if (!('companies' in value) || value['companies'] === undefined)
        return false;
    return true;
}
export function ListManagedCompaniesResultFromJSON(json) {
    return ListManagedCompaniesResultFromJSONTyped(json, false);
}
export function ListManagedCompaniesResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'companies': (json['companies'].map(ItemFromJSON)),
    };
}
export function ListManagedCompaniesResultToJSON(json) {
    return ListManagedCompaniesResultToJSONTyped(json, false);
}
export function ListManagedCompaniesResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'companies': (value['companies'].map(ItemToJSON)),
    };
}
